import { motion } from "framer-motion";
import { X } from "lucide-react";
import { LEVEL_STYLES } from "@/components/CreatorLevelBadge";
import { GemCinematic } from "@/components/GemCinematic";

/** Zoom gemma — rotazione 3D a schermo intero con bagliori. */
export const GemZoom = ({ level = 1, name, onClose }) => {
  const s = LEVEL_STYLES[level] || LEVEL_STYLES[1];
  return (
    <motion.div
      className="gz-root"
      data-testid="gem-zoom"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
      onClick={onClose}
    >
      <button className="gz-close" data-testid="gem-zoom-close" onClick={onClose}>
        <X className="w-4 h-4" />
      </button>

      <span className="gz-aura" style={{ background: `radial-gradient(circle, ${s.ring}66, ${s.ring}14 48%, transparent 70%)` }} />
      <span className="gz-rays" style={{ "--gz-ring": s.ring }} />
      {[...Array(10)].map((_, i) => (
        <span
          key={i}
          className="gz-spark"
          style={{
            left: `${12 + (i * 83) % 76}%`,
            top: `${18 + (i * 57) % 60}%`,
            background: i % 3 ? "#fff" : s.ring,
            animationDelay: `${i * 0.35}s`,
          }}
        />
      ))}

      <motion.div
        className="gz-stage"
        initial={{ scale: 0.4, rotateY: 0 }}
        animate={{ scale: 1, rotateY: 720 }}
        transition={{ duration: 1.8, ease: [0.16, 1, 0.3, 1] }}
        onClick={(e) => e.stopPropagation()}
      >
        <GemCinematic level={level} size="100%" mode="spin" delay={1.8} className="gz-gem" />
      </motion.div>

      <motion.p
        className="gz-name"
        style={{ textShadow: `0 0 50px ${s.ring}` }}
        initial={{ opacity: 0, y: 22 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.9, duration: 0.6 }}
      >
        {name || s.name}
      </motion.p>
      <motion.p className="gz-hint" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.6 }}>
        Tocca per chiudere
      </motion.p>
    </motion.div>
  );
};

export default GemZoom;
